module.exports = __webpack_public_path__ + "media/amp_version/apple-store-404f64dd.svg";